import { Phone, Mail, MapPin, Wind } from "lucide-react";
import { Link } from "react-router-dom";

const SiteFooter = () => {
  return (
    <footer className="bg-bark text-stone-light py-20">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center">
                <Wind className="w-4 h-4 text-primary-foreground" />
              </div>
              <span className="font-serif text-xl text-stone-light">Dust Monitoring London</span>
            </div>
            <p className="text-sm text-stone leading-relaxed font-light">
              Specialist construction dust monitoring services across London. Planning-compliant PM10 and PM2.5 boundary monitoring for contractors, developers, and demolition projects.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-5">
            <h4 className="font-serif text-base mb-5 text-stone-light">Dust Monitoring Services</h4>
            <ul className="space-y-2.5 text-sm text-stone font-light">
              <li><Link to="/construction-dust-monitoring-london" className="hover:text-primary transition-colors">Construction Dust Monitoring</Link></li>
              <li><Link to="/real-time-dust-monitoring" className="hover:text-primary transition-colors">Real-Time Monitoring</Link></li>
              <li><Link to="/dust-monitoring-planning-conditions" className="hover:text-primary transition-colors">Planning Conditions</Link></li>
              <li><Link to="/pm10-monitoring-construction" className="hover:text-primary transition-colors">PM10 Monitoring</Link></li>
              <li><Link to="/pm25-monitoring-construction" className="hover:text-primary transition-colors">PM2.5 Monitoring</Link></li>
              <li><Link to="/dust-monitoring-demolition-sites" className="hover:text-primary transition-colors">Demolition Monitoring</Link></li>
              <li><Link to="/dust-monitoring-complaints" className="hover:text-primary transition-colors">Complaint Investigation</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-serif text-base mb-5 text-stone-light">Navigate</h4>
            <ul className="space-y-2.5 text-sm text-stone font-light">
              <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/dust-monitoring-services-london" className="hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/request-quote" className="hover:text-primary transition-colors">Request Quote</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3 md:col-start-10">
            <h4 className="font-serif text-base mb-5 text-stone-light">Contact</h4>
            <ul className="space-y-3 text-sm text-stone font-light">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary shrink-0" />
                <a href="tel:08004337914" className="hover:text-primary transition-colors">0800 433 7914</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary shrink-0" />
                <a href="mailto:info@dustmonitoringlondon.co.uk" className="hover:text-primary transition-colors text-xs">info@dustmonitoringlondon.co.uk</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                <span>All London boroughs</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-bark-light mt-14 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-stone">
          <p>© {new Date().getFullYear()} Dust Monitoring London. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Construction dust monitoring services — London</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
